import { render, staticRenderFns } from "./UmfrageVersendenModal.vue?vue&type=template&id=562094e0"
import script from "./UmfrageVersendenModal.vue?vue&type=script&lang=js"
export * from "./UmfrageVersendenModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports